Monitoring.Views ||= {}

class Monitoring.Views.ArrivalAlertsView extends Backbone.View
  template: JST["backbone/templates/monitoring/arrival_alerts/arrival_alerts"]

  events :
    'click #new-arrival-alert': 'onClickNewAlert'

  initialize: (@options = {}) ->
    @arrivalAlerts     = @options.arrival_alerts
    @availableTopics   = @options.available_topics
    @availableTags     = @options.available_tags
    @availableGroups   = @options.available_groups
    @availableSubtypes = @options.available_subtypes
    @allSubtypes        = @options.all_subtypes
    @currentUser       = @options.current_user

  render: =>
    @listView.remove() if @listView
    @editView.remove() if @editView
    @$el.html(@template(@))
    @renderList()
    @

  renderList: =>
    @listView.remove() if @listView
    @listView = new Monitoring.Views.ArrivalAlertsListView({
      arrivalAlerts: @arrivalAlerts
      availableTopics: @availableTopics
      availableTags: @availableTags
      availableGroups: @availableGroups
      availableSubtypes: @allSubtypes
      currentUser: @currentUser
    })
    @$el.find('.list-view-container').append(@listView.render().el)
    @listenTo(@listView, 'edit', @renderEdit)

  onClickNewAlert: ->
    @renderEdit()

  renderEdit: (alert = new Monitoring.Models.ArrivalAlert) ->
    @editView.remove() if @editView
    @editView = new Monitoring.Views.ArrivalAlertsEditView({
      arrivalAlert: alert
      availableTopics: @availableTopics
      availableTags: @availableTags
      availableGroups: @availableGroups
      availableSubtypes: @availableSubtypes
      currentUser: @currentUser
    })
    @$el.find('.edit-view-container').html(@editView.render().el)
    @listenTo(@editView, 'cancel', @render)
    @listenTo(@editView, 'afterSave', @afterSave)

  afterSave: (newAlert) ->
    @arrivalAlerts.push(newAlert)
    @render()
